module.exports = __webpack_public_path__ + "img/info.e156fe6a.svg";